{
  "en": {
    "issue_status": {
      "actions": {
        "create": "Create Snagging Status"
      },
      "labels": {
        "customer_status": "Customer will see",
        "internal_status": "Internal status",
        "new_issue_status": "Status"
      }
    }
  }
}